/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reward: NonNullable<unknown> }} Check_In_Claim_ButtonInputs */

const en_check_in_claim_button = /** @type {(inputs: Check_In_Claim_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check in and claim ${i?.reward}`)
};

const es_check_in_claim_button = /** @type {(inputs: Check_In_Claim_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Registrarme y obtener ${i?.reward}`)
};

/**
* | output |
* | --- |
* | "Check in and claim {reward}" |
*
* @param {Check_In_Claim_ButtonInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_claim_button = /** @type {((inputs: Check_In_Claim_ButtonInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Claim_ButtonInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_claim_button(inputs)
	return es_check_in_claim_button(inputs)
});